import ShareableLinkDocumentsListEmptyState from './ShareableLinkDocumentsListEmptyState.component';

export default ShareableLinkDocumentsListEmptyState;
